
<template>
<v-layout justify-center>

  <v-dialog v-model="dialog2" max-width="500px">
    <variables v-if="dialog2" :dialog="dialog2" :item="selectedItem" @close-dialog="closeDialog"></variables>
  </v-dialog>

  <v-dialog v-model="dialog3" max-width="500px">
    <statistics v-if="dialog3" :dialog="dialog3" :item="prueba" @close-dialog2="closeDialog2"></statistics>
  </v-dialog>

  <v-dialog v-model="dialog4" max-width="500px">
    <prediction v-if="dialog4" :item="evalSelected" @close-dialog4="closeDialog4"></prediction>
  </v-dialog>

<v-data-table
  :headers="headers"
  :items="series"
  sort-by="calories"
  class="elevation-1"
>

<template v-slot:top>
  <v-toolbar flat color="white">
    <v-toolbar-title>Listado de datos</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
          color="primary"
          dark left
          outlined  
          class="mb-2 mr-2"
          @click="openStatistics">
            Estadísticas
          </v-btn>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          class="mb-2"
          v-bind="attrs"
          v-on="on"
        ><v-icon dark left>mdi-plus</v-icon>Iniciar prueba</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Iniciar prueba</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.name" label="Ingrese nombre"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="save">Iniciar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>
<template v-slot:item.name="{ item }">
  <router-link to="/datos">{{item.name}}</router-link>
</template>
<template v-slot:item.timestamp="{ item }">
  {{toNormalDate(item.timestamp)}}
</template>
<template v-slot:item.actions="{ item }">
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="downloadItem(item)">mdi-download</v-icon>
    </template>
    <span>Descargar serie</span>
  </v-tooltip>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="getJSONdata(item)">mdi-script-text</v-icon>
    </template>
    <span>Descargar variables</span>
  </v-tooltip>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" small class="mr-2" @click="analyzeItem(item)">mdi-chart-bar</v-icon>
    </template>
    <span>Gráficos</span>
  </v-tooltip>
  <v-tooltip bottom color="error">
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" :disabled="![1,2].some(r => usuario.groups.includes(r))" small class="mr-2" @click="deleteItem(item)">mdi-delete</v-icon>
    </template>
    <span>Borrar</span>
  </v-tooltip>
</template>
<template v-slot:item.evaluation="{ item }">
      <v-btn
      small
      dark left
      outlined
      color="primary"
      class="mb-2"
      @click="dialog4=true; evalSelected=item"
    >Evaluación</v-btn>
</template>

  <template v-slot:no-data>
    <div class="loader"></div>
  </template>
</v-data-table>

</v-layout>
</template>

<script>

  import Vue from 'vue'
  
  import Variables from './Variables.vue'
  import Statistics from './Statistics.vue'
  import Prediction from './Prediction.vue'

  import moment from 'moment';

  export default {
    data: () => ({
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      headers: [
        {
          text: 'Número',
          align: 'start',
          sortable: true,
          value: 'order',
        },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Fecha', value: 'timestamp' },
        { text: 'Acciones', value: 'actions', sortable: false },
        { text: 'Evaluación', value: 'evaluation', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      selectedItem: {
      },
      predicted: false,
      prob: 0.0,
      loading: false,
      evalSelected: {},
    }),

    computed: {
      prueba() {
        return this.$store.state.prueba
      },
      series() {
        return this.$store.state.series
      },
      token() {
        return this.$store.state.jwt;
      },
      usuario() {
        return this.$store.state.user;
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.desserts = [
        ]
        this.loading = true
        this.$store.dispatch('loadSeries',{id: this.prueba.id}).then(() => {
          this.loading = false
        })
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      deleteItem (item) {
        confirm('Está seguro que quiere eliminar este elemento?') && this.$store.dispatch('deleteSerie', {
          'id': this.prueba.id,
          'item': item
        });
      },

      analyzeItem (item) {
        this.selectedItem = item;
        this.dialog2 = true;
      },

      downloadItem (item) {

        Vue.axios.get('datos/' + item.id + '/')
          .then(result => {
            let csvContent = 'tiempo,ensayo,eje x,eje y,foco x,foco y,exito\n';
            let json =  JSON.parse(result.data['datos']);

            json.forEach(function(array) {
              const pos = array['position'];
              const front = array['frontPosition'];
              let row;
              if('platformFound' in array){
                row = [array['timestamp'], array['name'], pos._x, pos._z, front._x, front._z, array['platformFound']];
              }
              else{
                row = [array['timestamp'], array['name'], pos._x, pos._z, front._x, front._z];
              }
              csvContent += row.join(",") + "\r\n";
            });
            const anchor = document.createElement('a');
            anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
            anchor.target = '_blank';
            anchor.download = 'datos_'+item.nombre+'.csv';
            anchor.click();

          })
          .catch(error => {
            throw new Error(`API ${error}`);
          });

        /*
       
        */
      },

      getJSONdata (item) {

        Vue.axios.get('serie/' + item.id + '/')
          .then(result => {

            const anchor = document.createElement('a');
            anchor.href = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(result.data));
            anchor.target = '_blank';
            anchor.download = 'variables_'+item.nombre+'.json';
            anchor.click();

          })
          .catch(error => {
            throw new Error(`API ${error}`);
          });

      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDialog () {
        this.dialog2 = false;
      },

      closeDialog2 () {
        this.dialog3 = false;
      },

      closeDialog4() {
        this.dialog4 = false;
      },

      save () {
        //window.location.replace("http://localhost:8000/testing/" + this.prueba.id + "?name=" + this.editedItem.name);
        //window.location.replace("https://game.testvirtual.wic.cl//testing/" + this.prueba.id + "?name=" + this.editedItem.name);
        window.location.replace(process.env.VUE_APP_HOST + "testing/" + this.prueba.id + "?name=" + this.editedItem.name + '&token=' + this.token);
        //$.redirect(process.env.VUE_APP_HOST + "testing/" + this.prueba.id + "?name=" + this.editedItem.name, {'arg1': 'value1', 'arg2': 'value2'});
      },
      
      openStatistics() {
        this.dialog3 = true;
      },

      toNormalDate(timestamp) {
        return moment(timestamp).format("DD/MM/YYYY");
      },
    },

    components: {
    variables: Variables,
    statistics: Statistics,
    prediction: Prediction,
}
  }
</script>

<style scoped>

  .loader{  /* Loader Div Class */
    top:0px;
    right:0px;
    width:100%;
    height:100%;
    background-color:#eceaea;
    background-image: url('../assets/spinner.gif');
    background-size: 50px;
    background-repeat:no-repeat;
    background-position:center;
    z-index:10000000;
    opacity: 0.4;
    filter: alpha(opacity=40);
  }

</style>
